import {ref} from 'vue'
import {db} from '@src/services/db'
import {useObservable} from "@vueuse/rxjs";
import {liveQuery} from "dexie";
import Department from "@src/types/Department";

const loading = ref(false)

export function useDepartments() {

    function getDepartments() {
        return useObservable<Department[]>(
            //@ts-ignore
            liveQuery(async () => {
                    loading.value = true
                    const departments = await db.departments.toArray()
                    loading.value = false
                    return departments
                }
            ),
            { initialValue: [] }
        )
    }

    return {
        getDepartments,
        loading,
    }
}
